export default __webpack_public_path__ + "static/media/2b-UserPage.83bef39e.jpeg";